(function() {
    'use strict';
    angular
        .module('taskServiceApp')
        .factory('Feedback', Feedback);

    Feedback.$inject = ['$resource', 'DateUtils'];

    function Feedback ($resource, DateUtils) {
        var resourceUrl =  'api/feedbacks/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        console.log(data);
                        if (data.img!==null){
                           var imgs = data.img.split("*");
                           for (var i = 0; i<imgs.length;i++){
                               var item = {};
                               item.id = i;
                               item.url = imgs[i];
                               imgs[i] = item;
                           }
                           data.imgs = imgs;
                        }else {
                            data.imgs = null;
                        }
                        data.createTime = DateUtils.convertDateTimeFromServer(data.createTime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
